import { NetworkService } from '../../../../services/networkService';

export const fetchTruPointsCriteria = async () => {
  const response = await NetworkService.get('/api/tru_points');
  return response;
};
